<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">

    <el-dialog :visible.sync="automationTestDialog" title="" top="5vh" width="92%" @close="closeLogViewerDialog">
      <broadcast-history v-if="automationTestDialog" :statusId="1" :allowFilterBy="true" :singleAutomationTestHistory="selectedAutmationTest"></broadcast-history>
    </el-dialog>
    <el-dialog :visible.sync="logViewerDialog" title="" top="5vh" width="75%" @close="closeLogViewerDialog">
      <div v-if="singleRecordLog">
        <el-row :key="pKey" class="mb-2 w-100" v-for="(pKey, pVal) in logViewerData">
          <el-col :md="6" :lg="4" :sm="6">
            <span v-html="pVal" class="text-uppercase log-title"></span>
          </el-col>
          <el-col :md="18" :lg="20" :sm="18">
            <span class="app-bg-gold-low-alfa p-2" v-html="pKey" style="display: inline-block;width: calc(100% - 350px);word-break: break-all;"></span>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <el-row :key="mpKey" class="mb-2 w-100" v-for="(mpKey) in logViewerData">
          <el-row :key="pKey" class="mb-2 w-100" v-for="(pKey, pVal) in mpKey">
            <el-col :md="6" :lg="4" :sm="6">
              <span v-html="pVal" class="text-uppercase log-title"></span>
            </el-col>
            <el-col :md="18" :lg="20" :sm="18">
              <span class="app-bg-gold-low-alfa p-2" v-html="pKey" style="display: inline-block;width: calc(100% - 350px);word-break: break-all;"></span>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="90%">
      <moduleForm
          :actions_do_not_affect_system="actions_do_not_affect_system"
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="((editMode)? 'Update ' : 'Create ') + module.info.caption"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-6 pt-1">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search here"></dg-text-field>
      </div>
      <div class="col-12 col-md-6  pt-1">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <el-table
        :data="rowData"
        border
        cell-class-name="p-1"
        stripe
        style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
              :data="[props.row]"
              border
              cell-class-name="p-1"
              header-cell-class-name="app-light-silver-background p-1"
              style="width: 100%;">
            <el-table-column
                label="Destination"
                prop="destination_name">
            </el-table-column>
            <el-table-column
                label="Just Top"
                prop="using_only_top_destinations">
              <template slot-scope="scope">
                {{ (scope.row.using_only_top_destinations == 1) ? 'Yes' : 'No' }}
              </template>
            </el-table-column>
            <el-table-column
                label="Numbers"
                prop="phone_numbers_to_generate">
            </el-table-column>
            <el-table-column
                label="Caller"
                prop="caller_id">
            </el-table-column>
            <el-table-column
                label="Created"
                prop="created_at">
            </el-table-column>
          </el-table>

        </template>
      </el-table-column>
      <el-table-column
          label="Title"
          prop="title"
          width="250"
          sortable>
      </el-table-column>
      <el-table-column
          label="Division"
          width="80"
          prop="division_abbre">
      </el-table-column>
      <el-table-column
          label="Interval"
          width="80"
          prop="delay_between_calls_in_ms">
      </el-table-column>
      <el-table-column
          label="Calls Online"
          min-width="140"
          prop="">
        <template slot-scope="scope">
          <callsControl :status="scope.row.calls_are_active" :testId="scope.row.id"></callsControl>
          {{scope.row.number_of_calls_to_make}}
        </template>
      </el-table-column>
      <el-table-column
          label="Taking Action"
          min-width="150"
          prop="">
        <template slot-scope="scope">
          <takingActionControl :status="scope.row.is_taking_action" :testId="scope.row.id"></takingActionControl>
          <div style="cursor: pointer" class="text-info" @click="openAutomationTestHistory(scope.row)">{{scope.row.number_of_awaiting_actions_to_make}}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="Monitor"
          min-width="80"
          prop="">
        <template slot-scope="scope">
          <vSwitch fieldName="monitor_mode_for_tacking_actions" :value="scope.row.monitor_mode_for_tacking_actions" :customData="scope.row" :saveAction="updateField"></vSwitch>
        </template>
      </el-table-column>
      <el-table-column
          label="Action for All"
          min-width="110"
          prop="">
        <template slot-scope="scope">
          <vSwitch fieldName="take_action_on_all" :value="scope.row.take_action_on_all" :customData="scope.row" :saveAction="updateField"></vSwitch>
        </template>
      </el-table-column>
      <el-table-column
          align="right"
          min-width="75"
          label="Actions"
          prop="">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions"
                     :params="{data: scope.row, rowIndex: scope.$index + 1} "></vDropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  components: {
    broadcastHistory: () => import('@/modules/voip-testing-panel/old-broadcast-history/page/View.vue'),
    vSwitch: () => import('@/components/switch/View'),
    vDropdown: () => import('@/components/button-dropdown/View'),
    callsControl: () => import('./ag-grid/CallsControl'),
    takingActionControl: () => import('./ag-grid/TakingActionControl'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  props: {
    actions_do_not_affect_system: {
      default: 0
    }
  },
  data() {
    return {
      selectedAutmationTest: false,
      automationTestDialog: false,
      singleRecordLog: true,
      logViewerData: [],
      logViewerIntervalHandler: null,
      logViewerDialog: false,
      rowData: [],
      usersActions: [
        {
          label: 'View Log',
          icon: 'el-icon-view',
          action: 'openLogViewer'
        },
        {
          label: 'Remove',
          icon: 'el-icon-delete',
          action: 'removeAction'
        }
      ],
      intervalHandler: null,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.intervalHandler)
    clearInterval(this.logViewerIntervalHandler)
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
    this.intervalHandler = setInterval(() => {
      this.getEntityListData(this.currentPage, true)
    }, 12000)
  },
  methods: {
    openAutomationTestHistory (automationTest) {
      this.selectedAutmationTest = automationTest.id
      this.automationTestDialog = true
    },
    updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        this.afterSave(true)
        notify({
          type: 'success',
          title: "Updated",
        });
      }).catch( e => {
        this.afterSave(false)
        notify({
          type: 'error',
          title: "Failed",
        });
      })
    },
    getLogViewerData (testId, logType) {
      this.readAutomatedTestLiveLog({id: testId, status: logType}).then( r => {
        if (r.length && typeof r[0] == 'object') {
          this.singleRecordLog = false
          this.logViewerData = r
        } else {
          this.singleRecordLog = true
          //this.logViewerData = JSON.parse(r)
          this.logViewerData = r
        }

      })
    },
    openLogViewer(params) {
      let testId = params.data.id
      let monitorModeForTackingActions = params.data.monitor_mode_for_tacking_actions == 1
      let interval = (monitorModeForTackingActions)? 1000 : 4000
      this.getLogViewerData(testId, 'log')
      this.logViewerIntervalHandler = setInterval(() => {this.getLogViewerData(testId, 'log')}, interval)
      this.logViewerDialog = true;
    },
    closeLogViewerDialog(params) {
      this.logViewerData = []
      clearInterval(this.logViewerIntervalHandler)
      this.logViewerDialog = false;
    },
    getEntityListData(page, noLoadingScreen = false) {
      let data = {page: page, search: this.userSearch, actions_do_not_affect_system: this.actions_do_not_affect_system}
      if (noLoadingScreen) data['noLoadingScreen'] = true
      this.getEntityList(data).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.rowData = null
      $vue.nextTick(() => {
        this.rowData = response.rows
        this.recordsCounter = response.count
        this.amReady = true
      })
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions(module.info.name + '-api', {
      updateEntity: 'update',
      getEntityList: 'list',
      readAutomatedTestLiveLog: 'readAutomatedTestLiveLog'
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->voip-test-automation->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.getEntityListData(1, false)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.rowData.push(newEntity);
      this.dialogVisible = false;
      this.getEntityListData(1, false)
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
